import dayjs from 'dayjs';

import {
  SkypadPolicyStatus,
  KaminoPolicyStatus,
  type RentersPolicyStatusType,
} from './enums';

export const rentersRedStatuses: string[] = [
  SkypadPolicyStatus.Inactive,
  SkypadPolicyStatus.Expired,
  SkypadPolicyStatus.Suspended,
  SkypadPolicyStatus.PermSuspended,
  SkypadPolicyStatus.Cancelled,
  SkypadPolicyStatus.PermCancelled,
  SkypadPolicyStatus.PreCancelled,
];
export const isRentersRedStatus = (status: RentersPolicyStatusType) => rentersRedStatuses.includes(status);

export const isRentersGreenStatus = (status: RentersPolicyStatusType) => SkypadPolicyStatus.Active === status;
export const isRentersBlueStatus = (status: RentersPolicyStatusType) => SkypadPolicyStatus.Preactive === status || KaminoPolicyStatus.Preactive === status || KaminoPolicyStatus.Pending === status;

export const isActiveorPreActive = (status: RentersPolicyStatusType) => isRentersGreenStatus(status) || isRentersBlueStatus(status);

export const rentersMonochromeStatuses: string[] = [
  SkypadPolicyStatus.Unpaid,
  SkypadPolicyStatus.Predisbursement,
  SkypadPolicyStatus.Draft,
];
export const isRentersMonochromeStatus = (status: RentersPolicyStatusType) => rentersMonochromeStatuses.includes(status);

export const getStatusColor = (status: RentersPolicyStatusType, onError?: (status: string) => void) => {
  if (isRentersBlueStatus(status)) return 'primary';
  if (isRentersGreenStatus(status)) return 'success';
  if (isRentersMonochromeStatus(status)) return 'neutral';
  if (isRentersRedStatus(status)) return 'error';
  onError?.(status);
  return 'neutral';
};

export const getStatusLabel = (status: RentersPolicyStatusType, onError?: (status: string) => void) => {
  switch (status) {
    case SkypadPolicyStatus.Active: return 'active';
    case SkypadPolicyStatus.Preactive: return 'upcoming';
    case SkypadPolicyStatus.Cancelled: return 'cancelled';
    case SkypadPolicyStatus.Inactive: return 'inactive';
    case SkypadPolicyStatus.Expired: return 'expired';
    case SkypadPolicyStatus.Suspended: return 'suspended';
    case SkypadPolicyStatus.PermSuspended: return 'perm suspended';
    case SkypadPolicyStatus.PermCancelled: return 'perm cancelled';
    case SkypadPolicyStatus.PreCancelled: return 'pre cancelled';
    case SkypadPolicyStatus.Predisbursement: return 'pre disbursement';
    case SkypadPolicyStatus.Unpaid: return 'unpaid';
    case SkypadPolicyStatus.Draft: return 'draft';
    case KaminoPolicyStatus.Pending: return 'pending';
    default: {
      onError?.(status);
      return status;
    }
  }
};

export const canFileClaim = (coverageStartDate: string, policyStatus: RentersPolicyStatusType) => (
  (dayjs().isAfter(coverageStartDate) || dayjs().isSame(coverageStartDate, 'day'))
  && policyStatus === SkypadPolicyStatus.Active
);
export const hasNextPaymentDate = (policyStatus: RentersPolicyStatusType, isAutoRenew: boolean) => isActiveorPreActive(policyStatus) && isAutoRenew;
